(function( $ ) {
	$.fn.jPinning = function( options ) {
		// Default settings
		var defaults = {
			offset: false, //offset for header to hide or show in pixels
			onPin: function(){}, //Fires when the header shows up
			onUnpin: function(){} //Fires when the header hides out
		};
		// Merge default settings with user settings
		var settings = $.extend( {}, defaults, options );

		var elements = {
			lastScrollTop: 0,
      document: $(document),
			window: $(window),
			status: 'pinned'
		};

		var classes = {
			nav: 			'pinning-nav',
			pinned: 	'pinned',
			unpinned: 'unpinned',
			top: 			'pinning-top'
		};

		var methods = {

			isUnpinned: function(){
				/**
				* Check if header is unpinned
				* @return boolean
				*/
				if( elements.status == 'unpinned' )
					return true;
				return false;
			},

			isPinned: function(){
				/**
				* Check if header is pinned
        * @return boolean
				*/
				if( elements.status == 'pinned' )
					return true;
				return false;
			},

			prepare: function(){
				/*
				* This will add the needed classes for the header to work properly
				*/
				elements.target.addClass(classes.nav);
				elements.target.css('position', 'fixed');
			},

			pin: function(){
				/*
				* If the header is unpinned this function will update the status to "pinned",
				* update header classes and execute the callback function.
				*/
				if( methods.isUnpinned() ){
					elements.status = 'pinned';
					elements.target.removeClass(classes.unpinned).addClass(classes.pinned);
					settings.onPin.call( elements.target );
				}
			},

			unpin: function(){
				/*
				* If the header is pinned this function will update the status to "unpinned",
				* update header classes and execute the callback function.
				*/
				/*
				if( methods.isPinned() ){
					elements.status = 'unpinned';
					elements.target
						.removeClass(classes.pinned)
						.removeClass(classes.top)
						.addClass(classes.unpinned);
					settings.onUnpin.call( elements.target );
				}
                */
			},

      calcOffset: function(st){
        /**
         * Check if offset is setted and if so calculate it
         * @return boolean
         */

        if( settings.offset == 'auto' ){
          settings.offset = elements.target.outerHeight();
        }

        if( settings.offset ){
          if( st > settings.offset ){
            return true;
          }else {
            return false;
          }
        }else {
          return true;
        }
      },

			pinHandler: function(){
				/* 
				* This function will add "top" class to the header when it reachs the top of the page.
				* Also it will call pin() or unpin() functions depending if the user is scrolling up or down.
				*/
				var st = elements.window.scrollTop(),
        maxScroll = elements.document.height() - elements.window.height();

        if( st < 0 ) {
          st = 0;
        }

        if( st >= maxScroll ) {
          st = maxScroll;
          elements.lastScrollTop = st - 1;
        }

				if ( st == 0 ){
					elements.target.addClass(classes.top);
				}

			  if ( st <= elements.lastScrollTop ){
          /* Scrolling up */
          methods.pin();
			  } else {
          /* Scrolling down */
          var offset = methods.calcOffset(st);
          if( offset ){
            methods.unpin();
          }
			  }

			  elements.lastScrollTop = st;
			}
		};

		// jPinning init
		return this.each(function() {
			elements.target = $(this); //Get initialized element
			methods.prepare(); //Prepare element
			$(window).on( 'scroll', methods.pinHandler ); //Call handler on scroll
		});
	};
}( jQuery ));

Shopify.handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};
var owl_variant_gallery = null;
var owl_gallery = null;

(function($, window, document, undefined) {
  
  //$('.main_header').jPinning();
  
	var $win = $(window);
	var $doc = $(document);
	var $body = $('body');
	var $slider = $('.slider');
	var $sliderAnimated = $('.slider-animated');
  var $quotesAnimated = $('.quotes-animated');
  
	var $blogSliderAnimated = $('.blog_slider-animated');
    var $lamerSliderAnimated = $('.lamer-slider');
  
	var $header = $('.main_header');
	var $nav = $('.nav');
	var $jsNavBtn = $('.js-nav-toggle');
	var hiddenClass = 'hidden';
	var activeClass = 'active';
	var lastScrollTop = 0;

	/**
	 * Adds different classes to header when scrolling down and up
	 * @return {[type]} [description]
	 */
	function headerScroll() {
		var winScrollTop = $win.scrollTop();
		var $header = $('.main_header');

		scrollTop = $(this).scrollTop();

		//var isHeaderFixed = winScrollTop > 0;
		//$header.toggleClass('fixed', isHeaderFixed);

		lastScrollTop = scrollTop;
      
      	// hide megamenu when scrolling
        //$('.mega_nav_wrapper').find('.dropdown_container').hide();
      	$('.mega_nav_wrapper').hide();
	}

	/**
	 * Clones and appends Navigation to Header if viewport is mobile and detaches it if viewport is tablet and above
	 * @param  {[type]} conditionToAppend [description]
	 * @return {[type]}                   [description]
	 */
	function toggleNavAttachment(conditionToAppend, $clonedElement, $appendTo) {
		if (conditionToAppend && !$clonedElement.length) {
			$appendTo
				.closest('.main_header')
				.find('.link-cart')
				.clone()
				.appendTo($appendTo)
				.addClass('cloned');
		} else if (!conditionToAppend && $clonedElement.length) {
			$clonedElement.detach();
		}
	}

	/**
	 * Checks if device is mobile
	 * @return {Boolean} [description]
	 */
	function isMobile() {
		return $win.width() < 1041;
	}

	function stickySection() {
		var winScrollTop = $win.scrollTop();
		var headerHeight = $('.main_header').outerHeight();

		$('.sticky-section__element').each(function() {
			var $element = $(this);
			var elementTop = $element.offset().top;
			var elementHeight = $element.outerHeight();
			var $section = $element.parent();
			var sectionTop = $section.offset().top;
			var sectionHeight = $section.outerHeight();
			var actualScrollTop = winScrollTop + headerHeight;

          
			$section.toggleClass(
				'sticky-section',
				sectionTop < actualScrollTop - headerHeight &&
					elementTop < sectionTop + sectionHeight
              	

              
			);
			$element.toggleClass(
				'sticky-section__element--bottom',
				sectionHeight + sectionTop - elementHeight < actualScrollTop - headerHeight
			);
		});
	}
  
  var slideTimer = null;
  var transXVal = 0;
  var transXDelta = 0.4;//px
  
  function playSlideCarousel(){
    transXVal = transXVal - transXDelta;
    
    var stage = $('.slider-animated .owl-stage');
    var limit = - stage.width() + $win.width();
    
    if (transXVal < limit) {transXVal = 0;}
        
    stage.css('transform', 'translateX('+ transXVal + 'px)');
  };
  
  if ($sliderAnimated.length) {
    $sliderAnimated.each(function() {
      var $slider = $(this);


      var $slidesContainer = $slider.find('.slider__slides');

      var items = 4;
      if ($slidesContainer.hasClass('three')) items = 3;
      
      $slidesContainer.addClass('owl-carousel').owlCarousel({
        items: items,
        loop: true,
        dots: false,
        freeDrag: false,
        mouseDrag: false,
        touchDrag: false,
        lazyLoad: true,
              nav: true,
              navText: ["‹","›"],
        responsive: {
          0: {
            items: 1.35
          },
          768: {
            items: 3
          },
          1024: {
            items: items
          }
        }
      });
      
      var imgwidth = $('.slider__slide .widget.first img').width();
      $('.slider__slide .widget.first img').height(imgwidth);
      $('.founding-collection .slider__slide .widget.first img').height(imgwidth / 16 * 9);
      
      if (slideTimer == null) {
        console.log("Carousel timer started ----- start");
        slideTimer = setInterval(playSlideCarousel, 2);
      }

      var isDraggingSlider = false;
      var prevXPos = 0, clickedXPos = 0;
      
      $slidesContainer.css('cursor','pointer');
      $slidesContainer
      .on('mouseleave', function() {
        isDraggingSlider = false;
        slideTimer = setInterval(playSlideCarousel, 2);
      })
      .on('mouseenter', function() {
        clearInterval(slideTimer);
      })
      
      .on('mousedown', function(e) {
        isDraggingSlider = true;
        prevXPos = e.pageX;
        clickedXPos = e.pageX;
        
        return false;
      })
      .on('touchstart', function(e) {
        clearInterval(slideTimer);
        isDraggingSlider = true;
        prevXPos = e.originalEvent.touches[0].pageX;
        clickedXPos = e.originalEvent.touches[0].pageX;
        
      })
      .on('mousemove', function(e) {
        if (isDraggingSlider) {
          
          transXVal = transXVal + (e.pageX - prevXPos);
          prevXPos = e.pageX;
          
          var stage = $('.slider-animated .owl-stage');
          var limit = - stage.width() + $win.width();

          if (transXVal < limit) {transXVal = 0;}
          if (transXVal > 0) {transXVal = 0;}

          stage.css('transform', 'translateX('+ transXVal + 'px)');
          
        }
      })
      .on('touchmove', function(e) {
        if (isDraggingSlider) {
          
          
          transXVal = transXVal + (e.originalEvent.touches[0].pageX - prevXPos);
          prevXPos = e.originalEvent.touches[0].pageX;
          
          
          var stage = $('.slider-animated .owl-stage');
          var limit = - stage.width() + $win.width();

          if (transXVal < limit) {transXVal = 0;}

          stage.css('transform', 'translateX('+ transXVal + 'px)');
          
        }
      })
      .on('mouseup', function() {
        isDraggingSlider = false;
      })
      
      .on('touchend', function(e) {
        isDraggingSlider = false;
        slideTimer = setInterval(playSlideCarousel, 2);
        if (prevXPos == clickedXPos) {
          console.log("should work as normal touch");
        }
        else {
        	return false;
        }
      })
      
      .on('click', function(e) {
        isDraggingSlider = false;
        if (clickedXPos != e.pageX) {
          return false;
        }
        
      });
      
      var $prevbutton = $slidesContainer.find('.owl-prev');
      var $nextbutton = $slidesContainer.find('.owl-next');
      var imagewidth = $slidesContainer.find('.owl-item')[0].getBoundingClientRect().width;
      console.log(imagewidth);
      $prevbutton.off('click');
      $prevbutton.on('click', function(e) {
        clearInterval(slideTimer);
        
        var floatval = transXVal / imagewidth;
        var intval = Math.floor(floatval);
        transXVal = (intval + 1) * imagewidth;
        
          var stage = $('.slider-animated .owl-stage');
          var limit = - stage.width() + $win.width();

          if (transXVal < limit) {transXVal = 0;}
          if (transXVal > 0) {transXVal = limit;}

          stage.css('transform', 'translateX('+ transXVal + 'px)');
      })
      .on('mouseup', function() {
        clearInterval(slideTimer);
      })
      .on('touchend', function() {
        
        var floatval = transXVal / imagewidth;
        var intval = Math.floor(floatval);
        transXVal = (intval + 1) * imagewidth;
        
          var stage = $('.slider-animated .owl-stage');
          var limit = - stage.width() + $win.width();

          if (transXVal < limit) {transXVal = 0;}
          if (transXVal > 0) {transXVal = limit;}

          stage.css('transform', 'translateX('+ transXVal + 'px)');
        
        slideTimer = setInterval(playSlideCarousel, 2);
        return false;
      });
      $nextbutton.off('click');
      $nextbutton.on('click', function(e) {
        
        clearInterval(slideTimer);
        
        var floatval = transXVal / imagewidth;
        var intval = Math.ceil(floatval);
        transXVal = (intval - 1) * imagewidth;
        
          var stage = $('.slider-animated .owl-stage');
          var limit = - stage.width() + $win.width();

          if (transXVal < limit) {transXVal = 0;}
          if (transXVal > 0) {transXVal = limit;}

          stage.css('transform', 'translateX('+ transXVal + 'px)');
      })
      .on('mouseup', function() {
        clearInterval(slideTimer);
      })
      .on('touchend', function() {
        
        var floatval = transXVal / imagewidth;
        var intval = Math.ceil(floatval);
        transXVal = (intval - 1) * imagewidth;
        
          var stage = $('.slider-animated .owl-stage');
          var limit = - stage.width() + $win.width();

          if (transXVal < limit) {transXVal = 0;}
          if (transXVal > 0) {transXVal = limit;}

          stage.css('transform', 'translateX('+ transXVal + 'px)');
        
        slideTimer = setInterval(playSlideCarousel, 2);
        return false;
      });
      
    });
  }

  if ($quotesAnimated.length) {
    $quotesAnimated.each(function() {
      var $slider = $(this);
      var $slidesContainer = $slider.find('.slider__slides');
      var items = 1;


      $slidesContainer.addClass('owl-carousel').owlCarousel({
        items: items,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        thumbs: true,
        thumbsPrerendered: true,
        freeDrag: false,
        mouseDrag: true,
        touchDrag: true,
        lazyLoad: true,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 1,
          },
          1024: {
            touchDrag: false,
            items: items,
          },
        },
      });


    });
  }
  
  if ($blogSliderAnimated.length) {
		$blogSliderAnimated.each(function() {
          console.log("blog slider existing....");
			var $slider = $(this);
          
			var $slidesContainer = $slider.find('.slider__slides');

			$slidesContainer.addClass('owl-carousel').owlCarousel({
              items: 1,
              loop: true,
              dots: false,
              freeDrag: false,
              mouseDrag: false,
              touchDrag: false,
              lazyLoad: true,
              nav: true,
              navText: ["‹","›"]
			});
          
		});
	}
  
  // Cozy Slider

  var sectionHead = $('.cozy-featuredcollection .section__head-container'); 
  if($(window).width() < 992){
    sectionHead.detach(); 
    var owl = $('.cozy-featuredcollection .section__inner');
    owl.addClass('owl-carousel').owlCarousel({
      items: 2,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4000,
      margin: 10,
      freeDrag: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false,
      dots: true,
    });
    $(window).on('resize', function(){
    if($(window).width() > 992){
      owl.trigger('destroy.owl.carousel');
      owl.append(sectionHead);
    }
  });
  }
  
  
  

  // if($(window).width() > 992){
  //   owl.trigger('destroy.owl.carousel');
  // }

  
  
  
  var lamerslideTimer = null;
  var lamertransXVal = 0;
  var lamertransXDelta = 0.4;//px
  
  function playLamerSlideCarousel(){
    lamertransXVal = lamertransXVal - lamertransXDelta;
    
    var stage = $('.lamer-slider .owl-stage');
    var limit = - stage.width() + $win.width();
    
    if (lamertransXVal < limit) {lamertransXVal = 0;}
        
    stage.css('transform', 'translateX('+ lamertransXVal + 'px)');
  };
  
  if ($lamerSliderAnimated.length) {
    $lamerSliderAnimated.each(function() {
      var $slider = $(this);
      var $slidesContainer = $slider.find('.slider__slides');
      var items = 3.5;
      
      $slidesContainer.addClass('owl-carousel').owlCarousel({
        items: items,
        loop: true,
        dots: false,
        freeDrag: false,
        mouseDrag: false,
        touchDrag: false,

        lazyLoad: true,
        responsive: {
          0: {
            items: 1.35
          },
          768: {
            items: 2.5
          },
          1024: {
            items: items
          }
        }
      });
      
      if (lamerslideTimer == null) {
        console.log("Carousel timer started ----- start");
        lamerslideTimer = setInterval(playLamerSlideCarousel, 2);
      }

      var isDraggingSlider = false;
      var prevXPos = 0, clickedXPos = 0;
      
      $slidesContainer.css('cursor','pointer');
      $slidesContainer
      .on('mouseleave', function() {
        isDraggingSlider = false;
        lamerslideTimer = setInterval(playLamerSlideCarousel, 2);
      })
      .on('mouseenter', function() {
        clearInterval(lamerslideTimer);
      })
      
      .on('mousedown', function(e) {
        isDraggingSlider = true;
        prevXPos = e.pageX;
        clickedXPos = e.pageX;
        console.log(clickedXPos);
        return false;
      })
      .on('touchstart', function(e) {
        clearInterval(lamerslideTimer);
        isDraggingSlider = true;
        prevXPos = e.originalEvent.touches[0].pageX;
        clickedXPos = e.originalEvent.touches[0].pageX;
        
      })
      .on('mousemove', function(e) {
        if (isDraggingSlider) {
          lamertransXVal = lamertransXVal + (e.pageX - prevXPos);
          prevXPos = e.pageX;
          
          
          var stage = $('.lamer-slider .owl-stage');
          var limit = - stage.width() + $win.width();

          
          if (lamertransXVal < limit) {lamertransXVal = 0;}
          if (lamertransXVal > 0) {lamertransXVal = 0;}

          stage.css('transform', 'translateX('+ lamertransXVal + 'px)');
          
        }
      })
      .on('touchmove', function(e) {
        if (isDraggingSlider) {
          
          
          lamertransXVal = lamertransXVal + (e.originalEvent.touches[0].pageX - prevXPos);
          prevXPos = e.originalEvent.touches[0].pageX;
          
          
          var stage = $('.lamer-slider .owl-stage');
          var limit = - stage.width() + $win.width();

          if (lamertransXVal < limit) {lamertransXVal = 0;}

          stage.css('transform', 'translateX('+ lamertransXVal + 'px)');
          
        }
      })
      .on('mouseup', function() {
        isDraggingSlider = false;
      })
      
      .on('touchend', function(e) {
        isDraggingSlider = false;
        lamerslideTimer = setInterval(playLamerSlideCarousel, 2);
        if (prevXPos == clickedXPos) {
          console.log("should work as normal touch");
        }
        else {
        	return false;
        }
      })
      
      .on('click', function(e) {
        isDraggingSlider = false;
        if (clickedXPos != e.pageX) {
          return false;
        }
        
      });
      
    });
  }
  
  
	$jsNavBtn.on('click', function(e) {
		e.preventDefault();

		$body.toggleClass(activeClass);
	});

	$('.js-form-next').on('click', function(e) {
		e.preventDefault();
		$(this)
        	  .closest('.footer__aside-group')
        	  .find('.first-form')
        	  .addClass(hiddenClass);
        $(this)
        	  .closest('.footer__aside-group')
        	  .find('.second-form')
        	  .removeClass(hiddenClass);
      $(this)
        	  .closest('.footer__aside-group')
        	  .find('.first-form-title')
        	  .addClass(hiddenClass);
      $(this)
        	  .closest('.footer__aside-group')
        	  .find('.second-form-title')
        	  .removeClass(hiddenClass);

	});

	$win
		.on('load scroll', function() {
			headerScroll();
			stickySection();
		})
		.on('load resize', function() {
			$header.each(function() {
				var $this = $(this);
				toggleNavAttachment(
					isMobile(),
					$this.find('.cloned'),
					$this.find('.header__inner')
				);
			});
		});
  
  var galleryselector = '.gallery-items .gallery-item:not(".hdsm")';
  if ($( window ).width() < 767) {
    galleryselector = '.gallery-items .gallery-item__image:not(".right-image")';
  }
  	$(galleryselector).magnificPopup({
		delegate: 'a',
		type: 'image',
		mainClass: 'mfp-with-zoom mfp-img-mobile mfp-fade',
		removalDelay: 0,
		gallery: {
			enabled: true,
			navigateByImgClick: false,
			preload: [0, 1],

          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

          tPrev: 'Previous (Left arrow key)', // title for left button
          tNext: 'Next (Right arrow key)', // title for right button
          tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
		},
		image: {
          /*
			titleSrc: function(item) {
				return item.el.find('p').html();
			}
            */
		},
      callbacks: {
      }
	});


  $('.owl_gallery_popup').magnificPopup({
    delegate: 'a',
    type: 'image',
    //mainClass: 'mfp-with-zoom mfp-img-mobile mfp-fade',
    mainClass: 'mfp-fade',
    removalDelay: 300,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1]
    },
    zoom: {
      enabled: false, // By default it's false, so don't forget to enable it

      duration: 300, // duration of the effect, in milliseconds
      easing: 'ease-in-out', // CSS transition easing function

      opener: function(openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  });
 
  $('.owl_variant_gallery_popup').magnificPopup({
    delegate: 'a',
    type: 'image',
    //mainClass: 'mfp-with-zoom mfp-img-mobile mfp-fade',
    mainClass: 'mfp-fade',
    removalDelay: 300,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1]
    },
    zoom: {
      enabled: false, // By default it's false, so don't forget to enable it

      duration: 300, // duration of the effect, in milliseconds
      easing: 'ease-in-out', // CSS transition easing function

      opener: function(openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  }); 
  
  
	$('.popup-link').magnificPopup({
		type: 'inline',
		removalDelay: 300,
		mainClass: ' mfp-fade my-mfp-slide-bottom meterial'
	});

  
    $('.list-materials-block a').magnificPopup({
      type: 'inline',
      removalDelay: 300,
      mainClass: ' mfp-fade my-mfp-slide-bottom meterial material_popup'
    });
  /*
	// Swatch Zoom popup
	$('.list-materials').magnificPopup({
		delegate: 'li a',
		type: 'image',
		mainClass: 'mfp-with-zoom mfp-img-mobile mfp-fade meterial',
		removalDelay: 300,
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0, 1]
		},
		zoom: {
		    enabled: true, // By default it's false, so don't forget to enable it

		    duration: 300, // duration of the effect, in milliseconds
		    easing: 'ease-in-out', // CSS transition easing function

		    opener: function(openerElement) {
		      return openerElement.is('img') ? openerElement : openerElement.find('img');
		    }
		  }
	});

	if ($win.width() < 769) {
		$('.list-materials li a').one('click', function(event) {
			event.preventDefault();
		});
	}
  */
  
  $('.section .article__image').on('mouseover',function(e){
    $(this).next().addClass('hover');
  })
  
  $('.section .article__image').on('mouseleave',function(e){
    $(this).next().removeClass('hover');
  })
  
  
 // Drop Down menu -- Desktop
  if($(window).width() > 1040){
    
    $('.has-dropdown .site-nav__link').on('mouseover', function(e){
      var link_handle = $(this).text();
      
      //if (link_handle == "Visit") return;
      
      link_handle = Shopify.handleize(link_handle);
      $('.mega_nav_wrapper').find('.dropdown_container').hide();
      $('.mega_nav_wrapper').fadeIn(300);
      if ($('.mega_nav_wrapper').css('opacity') == 0) {
        $('.mega_nav_wrapper').find('div[data-dropdown="'+link_handle+'"]').show();
      }
      else {
      	$('.mega_nav_wrapper').find('div[data-dropdown="'+link_handle+'"]').fadeIn(300);
      }
    })
/*
    $('.mega_nav_wrapper .site-nav.has-dropdown').on('mouseleave', function(e){
      $('.mega_nav_wrapper').fadeOut(100);
      $('.mega_nav_wrapper').find('.dropdown_container').fadeOut(100);
    })
*/
    
    $('.mega_nav_wrapper').on('mousemove', function(e) {
      var y = e.pageY - $('.mega_nav_wrapper').offset().top;
      
      if (y < 80) {
        $('.mega_nav_wrapper').fadeOut(100);
        $('.mega_nav_wrapper').find('.dropdown_container').fadeOut(100);
      }
    });
    
    $('.mega_nav_wrapper').on('mouseleave', function(e) {
        $('.mega_nav_wrapper').fadeOut(100);
        $('.mega_nav_wrapper').find('.dropdown_container').fadeOut(100);
    });
    
  }
  else{
    // DropDown Menu -- Mobile
   
    $('.parent.site-nav__link.first').on('click touchend', function(e){
      e.preventDefault();
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $('ul.site-nav__submenu.third').slideUp();
        $('ul.site-nav__submenu.second').slideUp();
        $(this).next().slideUp();
      }
      else{
        $('.parent.site-nav__link.active.first').removeClass('active');
        $(this).addClass('active');
        $('ul.site-nav__submenu.third').slideUp();
        $('ul.site-nav__submenu.second').slideUp();
        $('ul.site-nav__submenu.first').slideUp();
        $(this).next().slideDown();
      }
    })
    
    $('.parent.site-nav__link.second').on('click touchend', function(e){
      e.preventDefault();
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $('ul.site-nav__submenu.third').slideUp();
        $(this).next().slideUp();
      }
      else{
        $('.parent.site-nav__link.active.second').removeClass('active');
        $(this).addClass('active');
        $('ul.site-nav__submenu.third').slideUp();
        $('ul.site-nav__submenu.second').slideUp();
        $(this).next().slideDown();
      }
    })
    
    
    $('.parent.site-nav__link.third').on('click touchend', function(e){
      e.preventDefault();
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).next().slideUp();
      }
      else{
        $('.parent.site-nav__link.active.third').removeClass('active');
        $(this).addClass('active');
        $('ul.site-nav__submenu.third').slideUp();
        $(this).next().slideDown();
      }
    })
  }
  
})(jQuery, window, document);


(function($) {
    //$.cookie('popupcoockie', 'true', { expires: 0}); /* MOVED HERE */
  
    if ($.cookie('popupcoockie')) {
      // it hasn't been three days yet
      
    } else {

      // set cookie to expire in 21 days
      $.cookie('popupcoockie', 'true', { expires: 21}); /* MOVED HERE */

    }
  
})(jQuery);


(function($) {
  $(window).load(function () {
    
  owl_gallery = $('.owl_gallery').owlCarousel({
 
    navSpeed : 1000,
    paginationSpeed : 400,
    singleItem:true,
    items: 1,
    itemsDestop: false,
    loop: true,
    dots: false,
    freeDrag: false,
    mouseDrag: false,
    touchDrag: false,
    nav: true,
    navText: ["‹","›"],
    pagination: true,

    lazyLoad: true,
    autoHeight: true
  });
  owl_gallery.on('changed.owl.carousel', function(event){
    var index = event.item.index;
    var element = $('.owl_gallery .owl-item:nth-child(' + (index+1) + ')');
    index = element.find('.owl_gallery_item').data('index');
    var description = element.find('.owl_gallery_item').data('description');
    
    //$('.owl_cur .current').html(index);
    $('.owl_gallery').next().find('.current').html(index);
    //$('.owl_gallery').siblings('.gallery-description').html(description);
  });
  
   $(document).on('click', '.owl_gallery_item', function() {
    if ($(this).hasClass('media-video')) {
      return;
    }

     var index = $(this).data('index');
     $('.owl_gallery_popup a[data-index="' + index + '"] img').trigger('click');
   });
  
  
  owl_variant_gallery = $('.owl_variant_gallery').owlCarousel({
 
    navSpeed : 1000,
    paginationSpeed : 400,
    singleItem:true,
    items: 1,
    itemsDestop: false,
    loop: true,
    dots: false,
    freeDrag: false,
    mouseDrag: false,
    lazyLoad: true,
    touchDrag: false,
    nav: true,
    navText: ["‹","›"],
    pagination: true,
    autoHeight: true
  });
  owl_variant_gallery.on('changed.owl.carousel', function(event){
    var index = event.item.index;
    var element = $('.owl_variant_gallery .owl-item:nth-child(' + (index+1) + ')');
    index = element.find('.owl_variant_gallery_item').data('index');
    var description = element.find('.owl_variant_gallery_item').data('description');
    
    //$('.owl_cur .current').html(index);
    $('.owl_variant_gallery').next().find('.current').html(index);
    //$('.owl_variant_gallery').siblings('.gallery-description').html(description);
  });
  /*
  $(document).on('click', '.list-materials li a', function() {
    var value = $(this).data('value');
    var index = 0;
    $('.owl_variant_gallery .owl_variant_gallery_item img').each(function(){
      if ($(this).attr('alt').localeCompare(value) == 0) {
        if (index == 0) {
          index = $(this).parent().data('index');
        }
      }
    });
    
    if (index != 0)
    {
      owl_variant_gallery.trigger('to.owl.carousel', index - 1);
    }
  });
  */
  /*
  $(document).on('updateSliderImage', function(evt){
    console.log('bbbbbbbbbbbbbbbbb');
    var value = evt.value;
    var index = 0;
    $('.owl_variant_gallery .owl_variant_gallery_item img').each(function(){
      if ($(this).attr('alt').localeCompare(value) == 0) {
        if (index == 0) {
          index = $(this).parent().data('index');
        }
      }
    });
    
    if (index != 0)
    {
      owl_variant_gallery.trigger('to.owl.carousel', index - 1);
    }
  });
  */
  $(document).on('click', '.owl_variant_gallery_item', function() {
    var index = $(this).data('index');
    $('.owl_variant_gallery_popup a[data-index="' + index + '"] img').trigger('click');
  });
  
    
    
    $('#mostread-carousel').owlCarousel({
      items: 3,
      loop: true,
      dots: false,
      freeDrag: false,
      mouseDrag: false,
      touchDrag: false,
      lazyLoad: true,
      nav: true,
      navText: ["‹","›"],
      responsive: {
        0: {
          	items: 1 
    	},
		768: {
			items: 3
		}
	  }
	});
    
    $('.slider-visit .slider__slides').addClass('owl-carousel').owlCarousel({
      items: 2.5,
      loop: true,
      autoplay: true,
      dots: false,
      freeDrag: false,
      mouseDrag: false,
      touchDrag: false,
      lazyLoad: true,
      nav: true,
      navText: ["‹","›"],
      responsive: {
        0: {
          	items: 1 
    	},
		768: {
			items: 2.5
		}
	  }
	});
    
    
     var imgwidth = $('.slider-visit .owl-item').width();
     $('.slider-visit .slider__slide .widget.first img').height(imgwidth * 1.4);
     $('.slider-visit .slider__slide.short .widget.first img').height(imgwidth * 1.18);
    
  });
})(jQuery);

var windowwidth = $(window).width();
$(window).on('resize', function(){
  
  setTimeout(function(){
   if($(this).width() != windowwidth){
     windowwidth = $(this).width();

     var imgwidth = $('.slider-visit .owl-item').width();
     $('.slider-visit .slider__slide .widget.first img').height(imgwidth * 1.4);  
     $('.slider-visit .slider__slide.short .widget.first img').height(imgwidth * 1.18); 

   }}, 500);
});

$(document).on('click', '.scrolltocartform', function(){ 
  event.preventDefault();

  $('html, body').animate({
    scrollTop: $($.attr(this, 'href')).offset().top
  }, 500);
}); 

$(window).load(function() {
  var url = window.location.href;
  if (url.indexOf('/blogs/news/') > -1) {
    url = url.replace('blogs/news/', 'blogs/the-eye/');
  	window.location.href = url;
  }
});

// ----- Mini Cart
$(document).ready(function() {
  
  updateMiniCart();
});

function updateMiniCart() {
  jQuery.getJSON('/cart.js', function(cart) {
    console.log(cart);
    if (cart.item_count == 0) {
      var cartstr = "<h4>Your Cart Is Empty</h4> \
      <a href='/account/login' class='link-primary link-primary--alt'>Log In</a> \
      <p>Log in to see your items whether you're shopping on your phone, tablet or computer.</p> \
      <a href='/account/register' class='link-primary link-primary--alt'>Create An Account</a>";
      
      $('.minicart-content').html(cartstr);
    }
    else {
      $('.minicart-content').html("");
      
      var htmlstr = "";
      htmlstr += "<ul class='minicart-item-list'>";
      $.each(cart.items, function (index, item) {
        htmlstr += "<li><div class='minicart-item-card'>";
        
        	htmlstr += "<div class='minicart-item-card-image'>";
        		htmlstr += "<a href='" + item.url + "'><img class=\"lozad\" src='" + item.image + "'></a>";
        	htmlstr += "</div>";
        
        	htmlstr += "<div class='minicart-item-card-info'>";
        		htmlstr += "<div class='minicart-item-card-title'>";
        			htmlstr += "<a href='" + item.url + "'>" + item.title + "</a>";
        		htmlstr += "</div>";
        		
        		htmlstr += "<div class='minicart-item-card-description'>";
                	htmlstr += "QUANTITY <span>" + item.quantity + '</span>';
                htmlstr += "</div>";
        
        		htmlstr += "<div class='minicart-item-card-price'>";
                	htmlstr += Shopify.formatMoney(item.line_price, "").replace(/((\,00)|(\.00))$/g, '').split('$')[1] + ' USD';
                htmlstr += "</div>";
        		
        	htmlstr += "</div>";
        
        htmlstr += "</div></li>";
          
      });
      htmlstr += "</ul>";
      
      htmlstr += "<div class='minicart-footer'>";
      	htmlstr += "<div class='minicart-footer-info'>";
      		htmlstr += "<span class='minicart-footer-info-label'>Subtotal</span><span class='minicart-footer-info-value'>"
            htmlstr += Shopify.formatMoney(cart.total_price, "").replace(/((\,00)|(\.00))$/g, '').split('$')[1] + ' USD';
      		htmlstr += "</span>";
      	htmlstr += "</div>";
      	htmlstr += "<div class='minicart-footer-actions'>";
      		htmlstr += "<div class='minicart-footer-btn minicart-footer-btn-view'>";
      			htmlstr += "<a href='/cart' class='link-primary' title='View cart'>View Cart</a>";
      		htmlstr += "</div>";
      		htmlstr += "<div class='minicart-footer-btn'>";
      			htmlstr += "<a href='/checkout' class='btn cart__btn'>Checkout</a>";
      		htmlstr += "</div>";
      	htmlstr += "</div>";
      htmlstr += "</div>";
      
      $('.minicart-content').html(htmlstr);
    }
  });
}
$('a.cart.mobile-only-menu').on('click', function(e) {
    e.preventDefault();
});

$('a.cart').on('mouseover', function(e) {
  e.preventDefault();
  $('.minicart').css('visibility', 'visible');
  $('.minicart').css('opacity', '1');
  //$('.global-overlay').show();
  
  var left = $(this).offset().left + $(this).width() - $('.minicart').outerWidth() ;
  var right = 0;
  var top = $(this).offset().top + 50;
  
  console.log('a.cart mouseover');
  
  //$('.minicart').css('left', left + 'px');
  $('.minicart').css('right', right + 'px');
  $('.minicart').css('top', top + 'px');
//   cartBodyLock()
  
});

$('a.cart').on('mouseleave', function(e) {
    console.log('a.cart mouseleave');
  $('.minicart').css('visibility', 'hidden');
  $('.minicart').css('opacity', '0');
  $('.global-overlay').hide();
//   cartBodyUnlock()
});

$('.minicart').on('mouseover', function(e) {
  $('.minicart').css('visibility', 'visible');
  $('.minicart').css('opacity', '1');
  $('.global-overlay').show();
//   cartBodyLock()
});
$('.minicart').on('mouseleave', function(e) {
  $('.minicart').css('visibility', 'hidden');
  $('.minicart').css('opacity', '0');
  $('.global-overlay').hide();
//   cartBodyUnlock()
});

$('.click-link').on('click', function() {
  var link = $(this).attr('data-link');
  window.open(link, "_self");
});


$(document).on('click', '.material-tab-title', function(){
  
  var material = $(this).data('material');
  var block = $('.material_block[data-material="' + material + '"]');
  
  $('.material-tab-title').each(function(){
    if (material.localeCompare($(this).data('material')) != 0 ) {
      $(this).removeClass('active');
    }
    else {
      $(this).toggleClass('active');
    }
  });
  
  $('.material_block').each(function(){
    if (material.localeCompare($(this).data('material')) != 0 ) {
      $(this).addClass('closed');
    }
    else {
      $(this).toggleClass('closed');
    }
  });
  
});

$(document).on('click', '.material_right_block .accordion', function(){
  $(this).parent().toggleClass('closed');
  var panel = this.nextElementSibling;
  if (panel.style.maxHeight){
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + "px";
  } 
});


$(document).on('click', '.link-scroll', function(){ 
  event.preventDefault();

  var header_height = $('.main_header').innerHeight();
  console.log(header_height);
  $('html, body').animate({
    scrollTop: $($.attr(this, 'href')).offset().top - header_height
  }, 500);
}); 

$(document).ready(function(){
  $('.list-materials-block a').on('click', function(){
    var $popup = $('#material_popup');

    $popup.find('img').attr('src', $(this).find('img').attr('src'));
    $popup.find('.title').html($(this).next().html());
    $popup.find('.material_right_description').html($(this).data('description'));
    $popup.find('.material_right_maintenance').html($(this).data('maintenance'));
    $popup.find('.material_right_maintenance').css('max-Height', '');
    $popup.find('.material_right_block:nth-child(2)').addClass('closed');

    $('.material_popup_image').trigger('zoom.destroy');
    $('.material_popup_image').zoom({touch: false});
  });

});


$(document).ready(function(){
  
  $(document).on('updateSliderImage', function(evt){
    var value = evt.value;
    var index = 0;
    
    $('.owl_variant_gallery .owl_variant_gallery_item img').each(function(){
      
      var alttext = $(this).attr('alt');
      
      if (value.localeCompare(alttext) == 0 || alttext.includes(value + ':')) {
        if (index == 0) {
          index = $(this).parent().data('index');
        }
      }
    });
    
    if (index != 0 && owl_variant_gallery != null)
    {
      owl_variant_gallery.trigger('to.owl.carousel', index - 1);
    }
  });

  // Set carousel to active swatch on initial page load.
  const setInitialCarouselSlide = () => {
    const refs = {
      activeSwatchEl: document.querySelector('.zoom__swatches.active'),
      carouselImageEl: document.querySelectorAll('.owl_variant_gallery_item img')
    }
    // Only proceed if all required elements exist
    if (Object.values(refs).some((el) => !el)) return
    console.log('setInitialCarouselSlide')
    const activeSwatchValue = refs.activeSwatchEl.dataset.value
    console.log('activeSwatchValue: ', activeSwatchValue)
    let matchFound = false
    refs.carouselImageEl.forEach((el) => {
      console.log('alt: ', el.alt)
      if (el.alt !== activeSwatchValue || matchFound) return
      matchFound = true
      console.log(`match: ${el.alt} --- ${activeSwatchValue}`)
      owl_variant_gallery.trigger('to.owl.carousel', el.parentElement.dataset.index - 1);
    })
  }
  // Checks if the plugin has loaded.
  // const timeoutId = setInterval(() => {
  //   console.log('<<<<loop>>>>>')
  //   if (owl_variant_gallery) {
  //     clearInterval(timeoutId)
  //     setInitialCarouselSlide()
  //   }
  // }, 500)
});


/* -------------- custom dropdown ---------------------- */
$(document).ready(function() {

  $('.select select').on('mousedown', function(e){
    if ($(this).parents('.contact-form').length > 0) { // contact form 
      return;
    }
    
    e.preventDefault();
    $('.select ul').hide();
    $(this).next().show();
  });

  $('.select li').on('click', function(){
    if (!$(this).hasClass('disabled')) {
      console.log('li--- clicked');
      var $select = $(this).parent().prev();
      $select.val($(this).data('value')).trigger('change');
      $(this).parent().hide();
    }
  });

   $(document).on('click', function(e){
     if (!$(e.target).hasClass('select')) {
       $('.select ul').hide();
     }
   });
});


/* -------------- Furniture LP Videos ---------------------- */
// $(document).ready(function () {
//     var x = document.querySelectorAll(".vimeo_video");
//     var nodelist = x.length;
//     alert(nodelist);

//     for (i = 0; i < nodelist; i++) {

//         var player = new Vimeo.Player(x[i]);

//         player.on('play', function () {
//             console.log('played the video!');
//             $('.video-overlay').hide();
//             $('.video-play').removeClass('paused');
//             $('.video-control-play').removeClass('paused');
//         });

//         player.on('ended', function () {
//             console.log('ended the video!');
//         });
//     }
// });